module.exports = __webpack_public_path__ + "static/media/correlation_one_logo.7ed0995d.png";